import React from 'react';
import { Route } from 'react-router-dom';
import EmailTemplateBuidler from './components/EmailTemplates/TemplateBuilder';

export default [
  <Route exact path="/templateBuilder" component={EmailTemplateBuidler} />,
];



// WEBPACK FOOTER //
// ./src/routes.js